import React from "react";
import type { CoilTab } from "../../../redux/coilConfigurator/ui/reducer";

const TABS: { id: CoilTab; label: string }[] = [
  { id: "configurations", label: "Configurations" },
  { id: "catalogue", label: "Catalogue" },
  { id: "assumptions", label: "Assumptions" },
  { id: "measured-data", label: "Measured Data" },
];

interface TabNavProps {
  activeTab: CoilTab;
  onChange: (tab: CoilTab) => void;
}

const TabNav = ({ activeTab, onChange }: TabNavProps) => (
  <nav className="tab-nav" role="tablist" aria-label="Module sections">
    <div className="tab-nav__inner">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`tab-button${activeTab === tab.id ? " tab-button--active" : ""}`}
          role="tab"
          aria-selected={activeTab === tab.id}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  </nav>
);

export default TabNav;
